import DetailLibraryInfo from './DetailLibraryInfo';

export default DetailLibraryInfo;
